import clsx from "clsx";

export function BulletSteps({
	steps,
	selectedIndex,
	navRef,
}: {
	steps: {
		id: string;
		name: string;
	}[];
	selectedIndex: number;
	navRef?: boolean;
}) {
	return (
		<nav
			className={clsx(
				navRef ? "bizF-mb-3" : "bizF-mb-0",
				"bizF-text-[--bizF-theme-accent] bizF-flex bizF-items-center bizF-justify-center"
			)}
			aria-label="Progress"
		>
			{steps.map((step, index) => (
				<p
					key={step.id}
					className="!bizF-pb-0 bizF-text-[--bizF-theme-accent] bizF-text-sm bizF-font-medium bizF-leading-4"
				>
					{index < selectedIndex
						? ""
						: index === selectedIndex
						? step.name
						: ""}
				</p>
			))}
			<ol
				role="list"
				className="!bizF-mb-0 bizF-ml-5 bizF-mr-5 bizF-flex bizF-items-center bizF-space-x-3 sm:bizF-space-x-5 sm:bizF-ml-8"
			>
				{steps.map((step, index) => (
					<li
						key={step.id}
						className="!bizF-list-none !bizF-pb-0 !bizF-mx-2 lg:!bizF-mx-2"
					>
						{index < selectedIndex ? (
							<button className="bizF-block bizF-h-2.5 bizF-w-2.5 bizF-rounded-full bizF-bg-[--bizF-theme-color] bizF-hover:bg-[--bizF-hover-color]">
								<span className="bizF-sr-only"></span>
							</button>
						) : index === selectedIndex ? (
							<button
								className="bizF-relative bizF-flex bizF-items-center bizF-justify-center"
								aria-current="step"
							>
								<span
									className="bizF-absolute bizF-flex bizF-h-5 bizF-w-5 bizF-p-px"
									aria-hidden="true"
								>
									<span className="bizF-h-full bizF-w-full bizF-rounded-full bizF-bg-[--bizF-bullet-bg]" />
								</span>
								<span
									className="bizF-relative bizF-block bizF-h-2.5 bizF-w-2.5 bizF-rounded-full bizF-bg-[--bizF-theme-color]"
									aria-hidden="true"
								/>
								<span className="bizF-sr-only"></span>
							</button>
						) : (
							<button className="bizF-block bizF-h-2.5 bizF-w-2.5 bizF-rounded-full bizF-bg-gray-200 hover:bizF-bg-gray-400">
								<span className="bizF-sr-only"></span>
							</button>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
}
